export class Theme {
  isNightTheme: boolean = false;
  secondaryColor: string = "#fafafa";
  secondaryTextColor: string = "";
  css: string = "";
  type: number = 0;
  description: string = "";
  name: string = "";
  state: number = 1;
  id: string = "00000000-0000-0000-0000-000000000000";
  lastUpdateTime: Date = new Date();
  locationId: string = "00000000-0000-0000-0000-000000000000";
  applicationThemeDetails: ApplicationThemeDetails = new ApplicationThemeDetails();
  loginThemeDetails: LoginThemeDetails = new LoginThemeDetails();
}

export class ApplicationThemeDetails {
  applicationLogoImage = new File([], "default");
  applicationLogoImageId = "00000000-0000-0000-0000-000000000000";
  applicationLogoImageUrl = "";
  primaryTextColor: string = "";
  primaryColor: string = "#2e4e5e";
}

export class LoginThemeDetails {
  loginBackgroundLandscapeImage = new File([], "default");
  loginBackgroundPortraitImage = new File([], "default");
  loginLogoImage = new File([], "default");
  loginBackgroundLandscapeImageId = "00000000-0000-0000-0000-000000000000";
  loginBackgroundPortraitImageId = "00000000-0000-0000-0000-000000000000";
  loginLogoImageId = "00000000-0000-0000-0000-000000000000";
  loginLogoImageUrl = "";
  loginBackgroundLandscapeImageUrl = "";
  loginBackgroundPortraitImageUrl = "";
}
